import { Tag, Input, Space, Table, TableProps } from "antd";
import TextArea from "antd/es/input/TextArea";
import Dragger from "antd/es/upload/Dragger";
import React, { useEffect, useRef, useState } from 'react';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import { Button, message, Upload } from 'antd';
import { CustomAxios } from "../../services/api";
import MessageListPopUp from "./message.list.modal";

import SockJS from 'sockjs-client';
import Stomp from 'stompjs';
import { API_BASE_URL } from "../../services/apiConfig";
import AuthService from "../../services/auth.service";
import '../styles/ChatScreen.css'
import { FileOutlined } from '@ant-design/icons';
interface TagPopUpProps {
  agentSeq?: any;
  clubSeq?: any;
  selectedRecord: any;
  memberid: any;
  tagAry: string[];
  chattingIsModalOpen: boolean;
}
const ChattingMessagePopUp: React.FC<TagPopUpProps> = ({ selectedRecord, tagAry, agentSeq, clubSeq, memberid, chattingIsModalOpen }) => {
  const [messages, setMessages] = useState<Message[]>([]);
  const [checkedTags, setCheckedTags] = useState<{ [key: string]: boolean }>({}); // 체크된 태그 상태 추가
  const handleCheckboxChange = (tag: string, checked: boolean) => {
    setCheckedTags({ ...checkedTags, [tag]: checked }); // 체크된 태그 상태 업데이트
  }; const [token, setToken] = useState<string | null>(null);


  const tokenRef = useRef(token);
  useEffect(() => {
    tokenRef.current = token;
  }, [token]);



  const [stompClient, setStompClient] = useState<Stomp.Client | null>(null);
  const [inputMessage, setInputMessage] = useState<string>('');

  const [updatetrigger, setupdatetrigger] = useState<boolean>(false);


  const memberidRef = useRef(memberid);
  useEffect(() => {
    memberidRef.current = memberid;
  }, [memberid]);


  const selectedRecordRef = useRef(selectedRecord);
  useEffect(() => {
    selectedRecordRef.current = selectedRecord;
  }, [selectedRecord]);

  interface Message {
    id: number;
    text: string;
    chattime: string;
    sender: string;
    originalFileName: any;
    fileUrl: any
    savedFileName: any;
  }

  useEffect(() => {
    const rawToken = AuthService.getRawToken();
    setToken(rawToken);
  }, []);


  useEffect(() => {

    // WebSocket 연결 설정

    const newSocket = new SockJS(API_BASE_URL + "/ws");
    const newStomp = Stomp.over(newSocket);
    const headers = { 'sender': memberidRef.current,'type':'chat' };
    const routingKey = clubSeq + "@" + memberidRef.current + "@" + selectedRecordRef.current["memberId"];
    console.log('Socket 연결시도' + stompClient);
    if (stompClient === null) {
      console.log("첫연결")
    } else {
      console.log("소켓종료필요")
      stompClient.disconnect(() => {
        console.log("WebSocket 연결이 종료되었습니다.");
      });
    }
    newStomp.connect(headers, (frame) => {
      console.log('Socket 연결완료');
      setStompClient(newStomp);
      newStomp.subscribe('/queue/subscribe-message/' + routingKey, (message) => {
        // 메시지가 도착할 때마다 상태 업데이트
        const newMessage = JSON.parse(message.body);

        // console.log("새 메세지 " + JSON.stringify(newMessage, null, 2))

        const currentUser = memberidRef.current;
        const chatMessages = Array.isArray(newMessage) ? // 새 메시지가 배열인지 확인
          newMessage.map((item: any) => ({ // 배열이라면 각각의 메시지를 가공하여 배열로 반환
            id: item.chatRoomSeq,
            text: item.message,
            chattime: item.korTime,
            sender: item.sender === currentUser ? "me" : "other",
            originalFileName: item.originalFileName,
            fileUrl: item.fileUrl,
            savedFileName: item.savedFileName

          })) : // 아니라면, 단일 메시지를 가공하여 배열로 변환
          [{
            id: newMessage.chatRoomSeq,
            text: newMessage.message,
            chattime: newMessage.korTime,
            sender: newMessage.sender === currentUser ? "me" : "other",
            originalFileName: newMessage.originalFileName,
            fileUrl: newMessage.fileUrl,
            savedFileName: newMessage.savedFileName
          }];

        // console.log("수정된 메세지: " + JSON.stringify(chatMessages, null, 2));

        const reversedMessages = chatMessages.reverse();


        setMessages(prevMessages => [...prevMessages, ...reversedMessages]); // 기존 메시지와 새로운 메시지 배열을 합침


      });
    }, (error) => {
      console.error('Socket connection error:', error);
    });





    // 컴포넌트 언마운트 시 WebSocket 연결 해제
  }, [selectedRecord]);



  useEffect(() => {
    if (token !== null) {
      fetchissuerMessageUpdate();
    }
  }, [token, selectedRecord]);


  const fetchissuerMessageUpdate = async () => {

    console.log("조회 APi실행" + "/" + clubSeq + "/" + memberid + "/" + selectedRecord["memberId"])
    try {
      const response = await fetch(
        `${API_BASE_URL}/club/chat/message/list/${clubSeq}/${memberid}/${selectedRecord["memberId"]}?page=0&size=100000&sort=chatRoomSeq,desc`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      // console.log("채팅데이터 : " + JSON.stringify(data, null, 2));
      const currentUser = memberid;
      const chatMessages = data.data.content.map((item: any) => ({
        id: item.chatRoomSeq,
        text: item.message,
        chattime: item.korTime,
        sender: item.sender === currentUser ? "me" : "other",
        originalFileName: item.originalFileName,
        fileUrl: item.fileUrl,
        savedFileName: item.savedFileName

      }));

      // console.log("채팅데이터2" + JSON.stringify(chatMessages, null, 2));
      const reversedMessages = chatMessages.reverse();
      setMessages(reversedMessages);
    } catch (error) {
      // console.error("(ExcelUpload) Error fetching data:", error);
    }
  };




  const handleOk = () => {
    // console.log("Checked selectedRecord?.clubMemberSeq:", selectedRecord?.clubMemberSeq);
    // console.log("Checked checkedTags:", checkedTags);

    const memoSettingData = {
      clubMemberSeq: Number(selectedRecord?.clubMemberSeq),
      memoData: JSON.stringify({ "회원태그": Object.entries(checkedTags).map(([key, value]) => ({ [key]: value })) })
    };

    // console.log(" memoSettingData:", memoSettingData);

    CustomAxios.patchUserMemoSetting(memoSettingData)
      .then((response: any) => {
        // console.log("postStudyCreateFile", response);
      })
      .catch((err: any) => {
        console.log("postStudyCreateFile error", err);
      });
  };
  const handleImageClick = (imageUrl: string) => {
    const newWindow = window.open(imageUrl, '_blank', 'noopener,noreferrer');
    if (newWindow) {
      newWindow.opener = null;
    }
  };

  useEffect(() => {
    setRefresh(Date.now());
    const newCheckedTags: { [key: string]: boolean } = {};
    tagAry.forEach(tag => {
      newCheckedTags[tag] = selectedRecord.memoData.includes(tag);
    });
    setCheckedTags(newCheckedTags);
  }, [tagAry]);


  const [textAreaValue, setTextAreaValue] = useState<string>('');

  const [fileList, setFileList] = useState<any[]>([]);
  const props: UploadProps = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
    },
    beforeUpload: (file) => {
      setFileList([...fileList, file]);

      return false;
    },
    fileList,
  };
  // TextArea 값 변경 이벤트 핸들러
  const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextAreaValue(e.target.value);
  };
  // 파일 업로드 상태 변경 이벤트 핸들러
  const handleFileChange = ({ fileList }: { fileList: any[] }) => {
    setFileList(fileList);
  };

  useEffect(() => {
    console.log("chattingIsModalOpen : " + chattingIsModalOpen)
  }, [chattingIsModalOpen]);



  const sendMessage = async () => {


    if (stompClient !== null) {
      if (fileList.length !== 0) {
        try {
          console.log("fileList: " + JSON.stringify(fileList, null, 2));

          const formData = new FormData();
          let chatMessageDto;
          if (inputMessage) {
            console.log("메세지있음")
            chatMessageDto = {
              'clubSeq': clubSeq,
              'routingKey': clubSeq + "@" + memberid + "@" + selectedRecord["memberId"],
              'sender': memberid,
              'receiver': selectedRecord["memberId"],
              'message': inputMessage
            }
          } else {
            console.log("메세지없음")
            chatMessageDto = {
              'clubSeq': clubSeq,
              'routingKey': clubSeq + "@" + memberid + "@" + selectedRecord["memberId"],
              'sender': memberid,
              'receiver': selectedRecord["memberId"],
            }
          }


          formData.append('chatMessageDto', new Blob([JSON.stringify(chatMessageDto)], { type: 'application/json' }));

          fileList.forEach((file, index) => {
            formData.append(`files`, file.originFileObj);
          });


          const response = await fetch(`${API_BASE_URL}/club/chat/message/create`, {
            method: 'POST',
            body: formData,

            headers: {
              Authorization: `Bearer ${token}`,

            },

          });

          if (response.ok) {
            console.log("파일 업로드 완료");
            // 필요한 추가 작업을 수행할 수 있습니다.
          } else {
            console.log("파일 업로드 실패 : " + response.status);
          }
        } catch (error) {
          console.log("파일 업로드 중 오류 발생:", error);
        }

        // console.log("확인3");
        setInputMessage('');
        setFileList([]);

      } else {
        stompClient.send("/app/rabbit/send-message", {}, JSON.stringify({
          'clubSeq': clubSeq,
          'routingKey': clubSeq + "@" + memberid + "@" + selectedRecord["memberId"],
          'sender': memberid,
          'receiver': selectedRecord["memberId"],
          'message': inputMessage
        }));
        // console.log("확인3")
        setInputMessage('');
        setFileList([])

      }
    }
  };
  const timestamp = Date.now();
  const [refresh, setRefresh] = useState(timestamp);



  return (
    <div style={{}}>
      <div style={{ height: '650px', overflowY: 'auto', marginBottom: "30px", scrollbarColor: "gray lightgray" }}>
        <div className="chat-screen-container">
          <div className="message-container">

            {messages.map((message) => (
              <div>
                {message.text !== null && (
                  <div key={message.id} className={`message ${message.sender === 'me' ? 'message-right' : 'message-left'}`} style={{ marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>
                    <div className={`message ${message.sender === 'me' ? 'message-right' : 'message-left'}`} style={{ marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>
                      <div className="message-text">{message.text}</div>

                    </div>
                  </div>
                )}

                {message.text !== null && (
                  <div style={{ width: "90px", backgroundColor: 'transparent', marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>{message.chattime}</div>
                )}
                {message.savedFileName !== "[]" && (

                  <>
                    {message.savedFileName && message.savedFileName.length > 2 && (
                      message.savedFileName.includes(",") ? (
                        message.savedFileName.split(",").map((fileName: any, index: any) => (
                          <div>
                            <div
                              key={index}
                              className={`message ${message.sender === 'me' ? 'message-right' : 'message-left'}`}
                              style={{
                                marginRight: message.sender === 'me' ? '0' : 'auto',
                                marginLeft: message.sender === 'me' ? 'auto' : '0'
                              }}
                              onClick={() => handleImageClick(`${message.fileUrl}${fileName.trim().replace(/\]/g, '').replace(/\[/g, '')}`)}
                            >
                              <img
                                src={`${message.fileUrl}${fileName.trim().replace(/\⧩✈⧨/g, ',').replace(/\]/g, '').replace(/\[/g, '')}`}
                                alt="File"
                                style={{ maxWidth: "100%", maxHeight: "100%" }}
                              />

                            </div>
                            <div style={{ width: "90px", backgroundColor: 'transparent', marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>{message.chattime}</div>
                          </div>

                        ))
                      ) : (
                        <div>
                          <div onClick={() => handleImageClick(`${message.fileUrl}${message.savedFileName.trim().replace(/\⧩✈⧨/g, ',').replace(/\]/g, '').replace(/\[/g, '')}`)} className={`message ${message.sender === 'me' ? 'message-right' : 'message-left'}`} style={{ marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>
                            {['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(message.savedFileName.split('.').pop().replace(/\]/g, '').replace(/\[/g, '')) ? (
                              <img src={`${message.fileUrl}${message.savedFileName.trim().replace(/\⧩✈⧨/g, ',').replace(/\]/g, '').replace(/\[/g, '')}`} alt="File" style={{ maxWidth: "100%", maxHeight: "100%" }} />
                            ) : (
                              <a href={`${message.fileUrl}${message.savedFileName.trim().replace(/\⧩✈⧨/g, ',').replace(/\]/g, '').replace(/\[/g, '')}`} download><FileOutlined /> {message.savedFileName.trim().replace(/\*/g, ',').replace(/\]/g, '').replace(/\[/g, '')}</a>
                            )}

                          </div>
                          <div style={{ width: "90px", backgroundColor: 'transparent', marginRight: message.sender === 'me' ? '0' : 'auto', marginLeft: message.sender === 'me' ? 'auto' : '0' }}>{message.chattime}</div>

                        </div>

                      )

                    )}
                  </>
                )}

              </div>

            ))}
          </div>
        </div>

      </div>
      <p>
        {tagAry.map((tag, index) => (
          <>
            <input
              key={`tag_${index}`}
              type="checkbox"
              id={`tag_${index}`}
              name={`tag_${index}`}
              value={tag}
              checked={checkedTags[tag] || false} // 체크된 태그인지 확인하여 checked 속성 설정
              onChange={(e) => handleCheckboxChange(tag, e.target.checked)} // 체크 상태 변경 핸들러
            />
            <label htmlFor={`tag_${index}`}>{tag}</label>
          </>
        ))}
        <Button type="primary" style={{ width: 100, marginLeft: 10 }} icon={<UploadOutlined />} onClick={handleOk}>태그변경</Button>
      </p>

      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <TextArea rows={7} placeholder="메시지작성" value={inputMessage} onChange={(e) => setInputMessage(e.target.value)} />

      </div>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>
        <Button type="primary" style={{ width: '100%' }} icon={<UploadOutlined />} onClick={sendMessage}>메시지전송</Button>
      </div>


      <div style={{ display: 'flex', flexDirection: 'row', width: '100%', marginTop: 10, marginBottom: 10 }}>
        <div style={{ flex: 1, display: 'flex', alignItems: 'center', padding: '3px' }}>

          <Dragger {...props}
            style={{ width: '100%' }}
            fileList={fileList}
            onChange={handleFileChange}
            multiple={true}
          >
            <p className="ant-upload-text"><InboxOutlined /> Click or drag file to this area to upload</p>
          </Dragger>

        </div>

      </div>


    </div>
  );
}
export default ChattingMessagePopUp;

